import { Alert, Icon, Text, openAlertModal } from '@inflearn/ds-react-next';
import { faEnvelope } from '@inflearn/pro-solid-svg-icons';
import { useTranslation } from 'next-i18next';

export function usePasswordSettingEmailModal() {
  const { t } = useTranslation();

  const openPasswordSettingEmailModal = (email: string) => {
    openAlertModal({
      size: 'sm',
      title: t('비밀번호 설정 메일 발송'),
      children: (
        <>
          <Alert
            type="default"
            radius="md"
            icon={<Icon icon={faEnvelope} />}
            title={email}
            mb={16}
          />

          <Text size="md" c="gray.7" ta="left">
            {t('위 이메일로 비밀번호 설정 메일이 발송되었습니다.')}

            <br />
            {t('메일이 확인되지 않을 경우, 스팸함을 확인해 주세요.')}
          </Text>
        </>
      ),

      labels: {
        confirm: t('확인'),
      },
      footerType: 'right',
      closeOnClickOutside: true,
      confirmProps: {
        color: 'infgreen',
        type: 'submit',
        size: 'md',
      },
    });
  };

  return { openPasswordSettingEmailModal };
}
